<template>
  <header class="w-full bg-white py-2 text-gray-600 font-semibold text-[17px] ">
    <div class="max-w-7xl mx-auto px-3 p-4 flex items-center justify-between">
      <!-- Left -->
      <div class="flex items-center gap-4 relative">
        <nav class="hidden md:flex items-center gap-4">
        </nav>

        <button
            class="md:hidden inline-flex items-center justify-center w-9 h-9 rounded-lg border border-gray-300"
            @click="menuOpen = true"
            aria-label="Open menu"
        >
          <span class="block w-5 h-[2px] bg-gray-600 relative">
            <span class="absolute -top-2 w-5 h-[2px] bg-gray-600"></span>
            <span class="absolute top-2 w-5 h-[2px] bg-gray-600"></span>
          </span>
        </button>
      </div>

      <div class="hidden md:flex items-center gap-4">
        <router-link
            :to="{ name: 'calculator' }"
            :class="[
            'hover:text-black transition-colors',
            isActive('calculator') ? 'text-black underline underline-offset-4 decoration-2' : ''
          ]"
            :aria-current="isActive('calculator') ? 'page' : null"
        >
          Calculator
        </router-link>


        <button
            v-if="isAuth"
            class="text-red-600 hover:text-red-700 inline-flex items-center gap-2"
            @click="logout"
        >
          <span class="inline-flex">
            <!-- svg -->
          </span>
          <span>Вийти</span>
        </button>
      </div>
    </div>

    <!-- Mobile slide-over -->
    <transition enter-active-class="transition duration-200"
                enter-from-class="opacity-0"
                enter-to-class="opacity-100"
                leave-active-class="transition duration-200"
                leave-from-class="opacity-100"
                leave-to-class="opacity-0">
      <div v-if="menuOpen" class="fixed inset-0 z-50 md:hidden" @click.self="menuOpen = false">
        <div class="absolute inset-0 bg-black/30"></div>
        <nav class="absolute left-0 top-0 h-full w-72 bg-white shadow-lg p-6">
          <div class="flex items-center justify-between mb-6">
            <span class="text-lg font-bold text-gray-800">Меню</span>
            <button class="w-9 h-9 inline-flex items-center justify-center rounded-lg border border-gray-300"
                    @click="menuOpen = false" aria-label="Close menu">✕</button>
          </div>

          <ul class="space-y-3">
            <li>
              <router-link
                  :to="{ name: 'calculator' }"
                  :class="[
                  'block px-3 py-2 rounded-lg transition-colors',
                  isActive('calculator') ? 'bg-gray-100 text-black' : 'hover:bg-gray-100'
                ]"
                  :aria-current="isActive('calculator') ? 'page' : null"
                  @clickmb-2="menuOpen=false"
              >Calculator</router-link>
            </li>

            <li>
              <router-link
                  :to="{ name: 'car-fax' }"
                  :class="[
                  'block px-3 py-2 rounded-lg transition-colors',
                  isActive('car-fax') ? 'bg-gray-100 text-black' : 'hover:bg-gray-100'
                ]"
                  :aria-current="isActive('car-fax') ? 'page' : null"
                  @clickmb-2="menuOpen=false"
              >Car Fax</router-link>
            </li>

            <li>
              <router-link
                  :to="{ name: 'news' }"
                  :class="[
                  'block px-3 py-2 rounded-lg transition-colors',
                  isActive('news') ? 'bg-gray-100 text-black' : 'hover:bg-gray-100'
                ]"
                  :aria-current="isActive('news') ? 'page' : null"
                  @clickmb-2="menuOpen=false"
              >News</router-link>
            </li>
          </ul>

          <!-- logout ... (без изменений) -->
        </nav>
      </div>
    </transition>
  </header>
</template>

<script>
import eventBus from "@/eventBus";

export default {
  name: "header-index",
  data() {
    return {
      isAuth: false,
      user: null,
      menuOpen: false,
    };
  },
  methods: {
    isActive(name) {
      return this.$route?.name === name;
    },
    logout() {
      localStorage.removeItem("token");
      sessionStorage.removeItem("readedNews");
      window.location.reload();
    },
  },
  mounted() {
    this.user = JSON.parse(localStorage.getItem("user"));
    this.isAuth = !!localStorage.getItem("token");
    eventBus.$on("login", () => {
      this.user = JSON.parse(localStorage.getItem("user"));
      this.isAuth = !!localStorage.getItem("token");
    });
  },
};
</script>